import * as actionTypes from './actionTypes';

export const tableStateChanged =  (myParam) => {
    return {type: actionTypes.TABLE_STATE_CHANGED, payload: myParam};
};